export default "__VITE_ASSET__1IN_Ahpn__"